import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Camera, Image as ImageIcon, ArrowLeft } from 'lucide-react';
import { capturePhoto, pickFromLibrary } from '../services/camera.js';
import { analyzeImage } from '../services/claudeApi.js';

const CATEGORY_LABELS = {
  appointment: 'Appointment card',
  bill: 'Bill',
  flyer: 'Event flyer',
  businesscard: 'Business card',
};

export default function CaptureScreen() {
  const { category } = useParams();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const handleSource = async (source) => {
    setError(null);
    setBusy(true);
    try {
      const photo = source === 'camera'
        ? await capturePhoto()
        : await pickFromLibrary();
      if (!photo) {
        setBusy(false);
        return;
      }
      const extracted = await analyzeImage({
        base64: photo.base64,
        mimeType: photo.mimeType,
        category,
      });
      navigate('/preview', {
        state: { category, extracted },
      });
    } catch (e) {
      console.error(e);
      setError(e.message || 'Something went wrong. Try again.');
      setBusy(false);
    }
  };

  return (
    <div>
      <button
        className="btn btn--ghost"
        onClick={() => navigate('/app')}
        style={{ marginBottom: 16 }}
      >
        <ArrowLeft size={16} /> Back
      </button>
      <h1 className="h1">{CATEGORY_LABELS[category] || 'Capture'}</h1>
      <p className="muted" style={{ marginBottom: 24 }}>
        Take a photo or pick one from your library.
      </p>

      {busy ? (
        <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="spinner" />
          <div>
            <div style={{ fontWeight: 600 }}>Analyzing…</div>
            <div className="muted">AI is reading the details out of your photo.</div>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <button className="btn btn--primary btn--block" onClick={() => handleSource('camera')}>
            <Camera size={18} /> Take photo
          </button>
          <button className="btn btn--ghost btn--block" onClick={() => handleSource('library')}>
            <ImageIcon size={18} /> Choose from library
          </button>
        </div>
      )}

      {error && (
        <div className="card" style={{ marginTop: 16, borderColor: 'var(--danger)', color: 'var(--danger)' }}>
          {error}
        </div>
      )}
    </div>
  );
}
